import React from 'react'
import { useDispatch } from 'react-redux'
import { removeUser } from '../../../../commons/redux/actions/user.actions'
import TagCustom from '../ServicesDemand/tag'

export default function ItemAdmin({ name, tel, email, district, town, _id }) {
  const dispatch = useDispatch()

  const removeAdmin = () => {
    dispatch(removeUser(_id))
  }

  return (
    <div>
      <div className=" border user_itembis p-2   my-3 flex-col">
        <h3 className="text-center font-bold text-sm text-green-500">
          Details du profil
        </h3>

        <div className="flex p-2 flex-wra justify-content-center text-center align-item-center align-content-center">
          <div className="text-xs text-muted p-2 w-50">
            <TagCustom size={'md'} price="Personnalite" colorScheme="blue" />
            <div className="flex-col my-1">
              <h6>Nom :</h6>
              <p className="font-bold text-black">{name}</p>
            </div>
            <div className="flex-col my-1 ">
              <h6>Tel :</h6>
              <p className="font-bold text-black">{tel}</p>
            </div>
            <div className="flex-col  my-1 ">
              <h6>Email :</h6>
              <p className="font-bold text-black">{email}</p>
            </div>{' '}
          </div>{' '}
          <div className="text-xs text-muted p-2 w-50">
            <TagCustom size={'md'} price="Adresse" colorScheme="cyan" />
            <h6>Ville :</h6>
            <p className="font-bold text-black">{town} </p>
            <h6>Quartier :</h6>
            <p className="font-bold text-black">{district}</p>
          </div>
        </div>
        <div className="flex text-xs justify-content-right align-items-center">
          <h3 className="text-black font-bold">CodeID :</h3>
          <p>{_id?.substring(_id.length - 4)}</p>
        </div>
        <div className="flex gap-2 mx-auto justify-content-center">
          <button className="btn btn-light font-bold bg-gray-200 text-sm btn-sm">
            Modifier
          </button>
          <button className="btn btn-danger font-bold bg-red0 text-white text-sm btn-sm">
            Supprimer
          </button>
        </div>
      </div>
    </div>
  )
}
